import React, { Component } from 'react';
import { Box } from '../../element';
class Footer extends Component {
  render() {
    return (
      <Box direction="column">
        <Box id="footer" className="hpe_slim_footer" />
      </Box>
    );
  }
}

export default Footer;
